export default __webpack_public_path__ + "assets/c2fdcefa902c538e5f8eebd1a9723dd1.svg";